module.exports = __webpack_public_path__ + "img/IMG_3119_L_Black_MockedUp.32530bb0.jpg";